export const descriptionChanged = (
  newDescription: string,
  { description }: { description: string }
) => newDescription !== description;
